


















































import Vue from 'vue';
import Curve1 from '@/assets/img/shapes/curves/curve-1.svg';
import SparkComments from '@/vue-components/sparks/SparkComments.vue'
import { SparkelloImageUtil, SparkWebDAO, WebSpark } from '@/web';
import HeartSpark from '@/vue-components/sparks/HeartSpark.vue';
import AddSpark from '@/vue-components/sparks/AddSpark.vue';

declare interface SparkViewData {
  localSpark: WebSpark | undefined;
  displayName: string;
  imageUri: string;
}

export default Vue.extend({
  name: 'SparkView',
  props: {
    id: String,
  },
  components: {
    SparkComments,
    Curve1,
    AddSpark,
    // HeartSpark,
  },
  data(): SparkViewData {
    return {
      localSpark: undefined,
      displayName: '',
      imageUri: '',
    };
  },
  computed: {
    spark(): WebSpark | undefined {
      //Get the dream data from the vuex store
      let spark: WebSpark | undefined = this.$store.state.sparkCache.index.get(this.id);

      //If the dream is not in the Vuex store it means the person has gone directly to this link
      //and the store is empty. Try getting it from the local data property which is set
      //asynchronously further down
      if (!spark && this.localSpark) {
        spark = this.localSpark;
      }
      return spark;
    },
    title(): string {
      const displayName = this?.spark?.displayName || this.displayName;
      if (displayName) {
        return 'Sparkello - ' + displayName;
      }
      return 'Sparkello - View Spark';
    },
  },
  created() {
    //On create check that the state store is populated, and if not then retrieve the individual
    // spark record.

    //Check the spark is in the store
    const spark: WebSpark | undefined = this.$store.state.sparkCache.index.get(this.id);

    if (spark) {
      SparkelloImageUtil.instance.getLargeImageSource(spark.image).then(uri => {
        this.$data.imageUri = uri;
        // this.$forceUpdate();
      });
    }

    //If the dream is not in the store store retrieve the data remotely and set it
    // in the localSpark data property
    if (!spark?.id) {
      SparkWebDAO.getInstance().getSpark(this.id).then((value: WebSpark | undefined) => {
        this.localSpark = value;
      }).catch((error) => {
        console.log(error);
      });
    }
  },
  methods: {
    sparkImageLarge(spark: WebSpark) {
      return SparkelloImageUtil.instance.getLargeImageSource(spark.image);
    }
  },
  watch: {
    spark: function (newSpark, oldSpark) {
      console.log('New spark', newSpark)
      this.displayName = newSpark?.displayName;
      document.title = 'Sparkello - ' + newSpark?.displayName;

      if (newSpark != oldSpark) {
        SparkelloImageUtil.instance.getLargeImageSource(newSpark.image).then(uri => {
          this.$data.imageUri = uri;
          this.$forceUpdate();
        });
      }
    },
  },
});
